import * as homeApi from '@/network/api/home.api.js'

/** requests Home Patrimony Data
@return {promise} - Home Patrimony request
*/
export const fetchPatrimony = async (context, payload) => {
    const res = await homeApi.requestHomePatrimony(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PATRIMONY_INFO', data)
    }
    return res
}

/** saves in our state current state, so when getting to patrimony from browser back click we re-render old display
@payload {Object}
@return {void}
*/
export const savePatrimonyBackState = async (context, payload) => {
    context.commit('SAVE_PATRIMONY_BACK_STATE', payload)
}
